export default "__VITE_ASSET__0LB_FWUX__"